import Reveal from "@/components/Reveal";

const STEPS = [
  ["Sourcing", "Long-staple Aegean cotton, selected bale by bale."],
  ["Weaving", "Dobby and jacquard looms, terry and flat-weave peshtemal."],
  ["Dyeing", "Reactive dyeing with OEKO-TEX minded chemistry."],
  ["Finishing", "Cutting, stitching, embroidery and hand-knotted fringes."],
  ["Control & Packing", "Piece-by-piece inspection, labelled and boxed for export."],
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-clay mb-6">
                04 — The Process
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
                From fibre
                <em className="italic text-clay"> to fold.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-smoke text-base sm:text-lg leading-relaxed max-w-md">
                Five stages, one roof. Keeping the whole journey in-house is
                how we hold quality — and deadlines — in our own hands.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            {STEPS.map(([title, body], i) => (
              <Reveal key={title} delay={0.06 * i}>
                <div
                  data-testid={`process-step-${i}`}
                  className="group flex items-baseline gap-6 sm:gap-10 py-7 border-t border-line last:border-b hover:bg-white/60 transition-colors duration-300 px-2 sm:px-4 -mx-2 sm:-mx-4"
                >
                  <span className="font-serif text-clay text-xl sm:text-2xl w-10 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-serif text-2xl sm:text-3xl font-light w-48 sm:w-64 shrink-0 group-hover:translate-x-1 transition-transform duration-300">
                    {title}
                  </h3>
                  <p className="text-smoke text-sm sm:text-base leading-relaxed hidden sm:block">{body}</p>
                </div>
                <p className="sm:hidden text-smoke text-sm leading-relaxed px-2 pb-4 -mt-2">{body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
